<ng-container *ngIf="changePasswordSuccess">
  <div class="d-flex justify-content-center align-items-center vh-100">
    <div class="d-flex flex-column align-items-center resetSuccess">
      <h2 translate="forget.passwordEditSuccess"></h2>
      <div translate="forget.passwordEditSuccessText"></div>
      <button
        routerLink="/"
        class="btn btn-lg btn-primary btn-login mt-5"
        translate="forget.goLogin"
      ></button>
    </div>
  </div>
</ng-container>
<ng-container *ngIf="!changePasswordSuccess">
  <form class="page d-flex flex-column justify-content-center align-items-center">
    <div class="d-flex flex-column group-login">
      <h2 class="d-flex justify-content-center title mb-5" translate="forget.welcome"></h2>

      <label class="form-label label" translate="forget.create-password"></label>
      <div class="input-group">
        <input
          id="password"
          [(ngModel)]="password"
          [ngModelOptions]="{ standalone: true }"
          [ngClass]="{ 'is-invalid': hasError }"
          class="form-control"
          placeholder="********"
          [type]="showPassword ? 'text' : 'password'"
        />
        <div class="input-group-text pointer">
          <span class="material-icons eye" (click)="showPassword = !showPassword">{{
            showPassword ? 'visibility_off' : 'visibility'
          }}</span>
        </div>
      </div>

      <label class="form-label label mt-3" translate="forget.confirm-password"></label>
      <div class="input-group">
        <input
          id="password2"
          [(ngModel)]="confirmPassword"
          [ngModelOptions]="{ standalone: true }"
          [ngClass]="{ 'is-invalid': hasError }"
          class="form-control"
          placeholder="********"
          [type]="showPassword2 ? 'text' : 'password'"
        />
        <div class="input-group-text pointer">
          <span class="material-icons eye" (click)="showPassword2 = !showPassword2">{{
            showPassword2 ? 'visibility_off' : 'visibility'
          }}</span>
        </div>
      </div>
      <div class="mt-3">
        <div translate="forget.passwordComposition.title"></div>
        <div
          class="mt-3"
          [class.rules-success]="password && password.length >= 12"
          [class.rules-error]="password && password.length < 12"
        >
          <img
            class="cross-circled"
            [class.cross-success]="password && password.length >= 12"
            [class.cross-error]="password && password.length < 12"
            src="assets/image/deactivated.svg"
            alt="cross"
          />
          <span translate="forget.passwordComposition.characters"></span>
        </div>
        <div
          [class.rules-success]="password && checkOneCapitalLetter"
          [class.rules-error]="password && !checkOneCapitalLetter"
        >
          <img
            class="cross-circled"
            [class.cross-success]="password && checkOneCapitalLetter"
            [class.cross-error]="password && !checkOneCapitalLetter"
            src="assets/image/deactivated.svg"
            alt="cross"
          />
          <span translate="forget.passwordComposition.capitalLetter"></span>
        </div>
        <div
          [class.rules-success]="password && checkOneLowercaseLetter"
          [class.rules-error]="password && !checkOneLowercaseLetter"
        >
          <img
            class="cross-circled"
            [class.cross-success]="password && checkOneLowercaseLetter"
            [class.cross-error]="password && !checkOneLowercaseLetter"
            src="assets/image/deactivated.svg"
            alt="cross"
          />
          <span translate="forget.passwordComposition.lowercaseLetter"></span>
        </div>
        <div
          [class.rules-success]="password && checkOneSpecialCharacter"
          [class.rules-error]="password && !checkOneSpecialCharacter"
        >
          <img
            class="cross-circled"
            [class.cross-success]="password && checkOneSpecialCharacter"
            [class.cross-error]="password && !checkOneSpecialCharacter"
            src="assets/image/deactivated.svg"
            alt="cross"
          />
          <span translate="forget.passwordComposition.specialCharacter"></span>
        </div>
        <div
          [class.rules-success]="password && checkOneDigit"
          [class.rules-error]="password && !checkOneDigit"
        >
          <img
            class="cross-circled"
            [class.cross-success]="password && checkOneDigit"
            [class.cross-error]="password && !checkOneDigit"
            src="assets/image/deactivated.svg"
            alt="cross"
          />
          <span translate="forget.passwordComposition.digit"></span>
        </div>
      </div>
      <button
        id="submit"
        (click)="resetPassword()"
        class="btn btn-lg btn-primary btn-login mt-5"
        translate="forget.continue"
      ></button>
      <label
        class="d-flex justify-content-center goLogin"
        routerLink="/"
        translate="forget.sign_in"
      ></label>
    </div>
  </form>
</ng-container>
